import { LitElement, html, css, PropertyValues } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { styleMap } from 'lit-html/directives/style-map';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';

@customElement('voy-dot-menu')
export class VoyDotMenu extends LitElement
{
    @property({type: Number}) top: number = 0;
    @property({type: Number}) left: number = 0;
    @property({type: Number}) right: number = 0;
    @property({ attribute: false }) dotMenuTitle?: any;
    @property({ attribute: false }) controlableClose: boolean = false;
    @property({ attribute: false }) showMenu: boolean = false;
    @property({ attribute: false }) private _menuOffset: string = '0px';
    @property({ attribute: false }) section?: string;

    private _launchineMenu: boolean = false;

    static get styles()
    {
        return [
            css`
            :host {
                display: inline-flex;
                flex-direction: column;
                position: relative;
            }

            .container {
                position: absolute;
                top: 0;
                left: 0;
                padding: 16px;
                border: 1px solid var(--neutrals-grey-07, grey);
                border-radius: 3px;
                box-shadow: 0 2px 4px 0 var(--voyage-box-shadow, rgba(0,0,0,0.15));
                background-color: var(--neutrals-grey-10, white);
                display: none;
            }

            .container[showmenu] {
                display: block;
                position: fixed;
                top: 168px;
                margin-left: 128px;
            }

            .port-memo[showmenu] {
                display: block;
                position: fixed;
                top: 220px;
                margin-left: 24px;
            }   
            
            .application[showmenu]{
                display: block;
                position: fixed;
                top: 239px;
                margin-left: 90px;
            }

            .launchbutton svg {
                width: 15px;
                height: 15px;
                margin-left: 8px;
                margin-bottom: -3px;
            }

        
            .launchbutton[withTitle]{
                padding-left: 0px;
                padding-right: 8px;
            }

            .launchbutton {
                border: none;
                background: inherit;
                padding-right: 0px;
            }

            .container > button svg {
                width: 16px;
                height: 16px;
                margin-right: 5px;
            }
            .header {
                font-family: MaerskText;
                color: var(--voyage-blue-dark);
                text-align: left;
                cursor: pointer;
                padding: 0;
                height: 26px;
                line-height: 26px;
                margin: 0px;
            }
            .see-vessels-header{
                font-family: MaerskText;
                color: var(--voyage-blue-dark);
                text-align: left;
                cursor: pointer;
                padding: 0;
                margin: 0px;
                margin-top: -2px;
            }
            `
        ];
    }

    constructor()
    {
        super();

        this._onClickOutside = this._onClickOutside.bind(this);
        this._launchMenu = this._launchMenu.bind(this);
    }

    connectedCallback()
    {
        super.connectedCallback();
        if(!this.controlableClose){
            document.body.addEventListener('click', this._onClickOutside);
        }
    }

    disconnectedCallback()
    {
        super.disconnectedCallback();
        if(!this.controlableClose){
            document.body.removeEventListener('click', this._onClickOutside);
        }
    }

    render()
    {
        let className = this._getClassName(this.section)
        let iconClassName = this.section == "application-link" ?  "launchbutton seeVesselIn" : "launchbutton";
        let headerClass = this.section != "application-link" ? "header" : "see-vessels-header";
        return html`
        <button class= ${iconClassName} @click=${this._launchMenu} ?withTitle=${this.dotMenuTitle}>${this.dotMenuTitle ? html`<p class=${headerClass}>${this.dotMenuTitle}</p>`: html`<span>${SvgIcons.ellipsisH}</span>`}</button>
        <div class=${className} ?showmenu=${this.showMenu} style=${styleMap({left: this._menuOffset})} @click=${ (evt: Event) => {
            if( !this.controlableClose) {
                this.showMenu = false;
            }
        }}>
            <slot></slot>
        <div>
        `;
    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has("showMenu")) {
          this.dispatchEvent(new CustomEvent("show-menu-updated", {detail: {state: this.showMenu}}));
        }
    }

    private _launchMenu(e: Event) {
        if (this.showMenu) {
            this._onClickOutside(e);
        } else {
            this.showMenu = true;
            this._launchineMenu = true;
            const rect = this.getBoundingClientRect();
            this._menuOffset = rect.width + this.right + 'px';
        }
    }

    private _onClickOutside(e: Event): void
    {
        if (this._launchineMenu && !this.controlableClose) {
            this._launchineMenu = false;
            return;
        }
        this.showMenu = false;
        this._launchineMenu = false;
    }

    private _getClassName(section : any){
        switch(section){
            case "portmemo" : 
                return "container port-memo";
            case "application-link" : 
                return "container application";
            default : 
                return "container";

        }
    }
};
